// 主題限制配置
// 每個主題可以配置：
// - blockedRoutes: 完全阻止的路由列表（支持前綴匹配）
// - prefixBlocked: 前綴阻止但有例外規則的列表
// - redirectTo: 被阻止時重定向的路徑
const THEME_RESTRICTIONS = {
  theme_purple: {
    blockedRoutes: [
      '/user/KYC',
      '/user/news'
    ],
    prefixBlocked: [

    ],
    redirectTo: '/'
  }
}

// 檢查路徑是否被限制
function isRouteBlocked(targetPath, restrictions) {
  const { blockedRoutes = [], prefixBlocked = [] } = restrictions

  // 1. 檢查完全阻止的路由（前綴匹配）
  const isFullyBlocked = blockedRoutes.some(blockedRoute => {
    return targetPath === blockedRoute ||
           targetPath.startsWith(blockedRoute + '/')
  })

  if (isFullyBlocked) return true

  // 2. 檢查前綴阻止但有例外的路由
  for (const rule of prefixBlocked) {
    const { prefix, exceptions = [] } = rule

    // 如果路徑符合前綴
    if (targetPath === prefix || targetPath.startsWith(prefix + '/')) {
      // 檢查是否在例外清單中
      const isException = exceptions.some(exception => {
        return targetPath === exception ||
               targetPath.startsWith(exception + '/')
      })

      // 如果不在例外清單中，則阻止
      if (!isException) {
        return true
      }
    }
  }

  return false
}

// 獲取當前主題（優先從 localStorage，否則從環境變量）
function getCurrentTheme() {
  // 嘗試從 localStorage 獲取（支持動態切換主題）
  const storedTheme = localStorage.getItem('theme')
  if (storedTheme && THEME_RESTRICTIONS[storedTheme]) {
    return storedTheme
  }

  // 回退到環境變量
  return process.env.VUE_APP_THEME
}

// 導出檢查函數
function checkThemeRestrictions(to) {
  const currentTheme = getCurrentTheme()

  // 如果沒有配置該主題的限制，則允許訪問
  const restrictions = THEME_RESTRICTIONS[currentTheme]
  if (!restrictions) {
    return {
      blocked: false
    }
  }

  // 檢查路由是否被阻止
  if (isRouteBlocked(to.path, restrictions)) {
    console.warn(`[主題限制] 主題 "${currentTheme}" 不允許訪問路由: ${to.path}`)
    return {
      blocked: true,
      redirectTo: restrictions.redirectTo || '/'
    }
  }

  return {
    blocked: false
  }
}

export { checkThemeRestrictions }
